import template from './TheHeader.html';
import config from '../../../../configs/config';

export default {
	template,
	data() {
		return {
			isLoggingOut: false
		};
	},
	methods: {
		async logout() {
			this.isLoggingOut = true;
			await this.app.logout();
			this.isLoggingOut = false;
		},
		getProfilePicUrl() {
			let endpointBase = config.endpointBase || '';
			return endpointBase + '/api/profile-pic?' + this.app.user.id;
		}
	}
}